import React from 'react'
import PropTypes from 'prop-types'

import { TRUE_FALSE_OPTIONS, YES_NO_OPTIONS } from 'utils/enums/questions'
import { FormRadioButtonGroup } from 'components/form/radioButtonGroup/FormRadioButtonGroup'
import { validateRequiredField } from 'utils/helpers/validators/byType/requiredField'

import styles from '../FormByState.module.scss'

export const PaFormConfig = {
  wasSubjectOfAbuse: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
  wasResigned: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
  wasLicenseRevoked: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
  noEvidence: {
    required: formData => !formData.unknownPerson.value,
    validator: validateRequiredField,
  },
}

export const PAForm = ({ formData, handleFieldChange }) => (
  <div className={styles.form}>
    <FormRadioButtonGroup
      title="Has Applicant ever been the subject of an abuse or sexual misconduct investigation by any employer, state licensing agency, law enforcement agency or child protective services agency (unless the investigation resulted in a finding that the allegations were false)"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.wasSubjectOfAbuse}
      handleFieldChange={handleFieldChange}
    />

    <FormRadioButtonGroup
      title="Has Applicant ever been disciplined, discharged, non-renewed, asked to resign from employment, resigned from or otherwise separated from employment while allegations of abuse or sexual misconduct were pending or under investigation or due to adjudication or findings of abuse or sexual misconduct?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.wasResigned}
      handleFieldChange={handleFieldChange}
    />

    <FormRadioButtonGroup
      title="Has Applicant ever had a license, professional license or certificate suspended, surrendered or revoked while allegations of abuse or sexual misconduct were pending or under investigation or due to an adjudication or findings of abuse or sexual misconduct?"
      className={styles.radioButtonQuestion}
      options={YES_NO_OPTIONS}
      field={formData.wasLicenseRevoked}
      handleFieldChange={handleFieldChange}
    />

    <FormRadioButtonGroup
      title="No records or other evidence currently exists regarding the above questions. I have no knowledge of information pertaining to the applicant that would disqualify the applicant from employment."
      className={styles.radioButtonQuestion}
      options={TRUE_FALSE_OPTIONS}
      field={formData.noEvidence}
      handleFieldChange={handleFieldChange}
    />
  </div>
)

PAForm.propTypes = {
  formData: PropTypes.object.isRequired,
  formMeta: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
}
